<script setup>
import { Row, Toggle, Hints, Heading, Input, Select } from '@components'
import DarkModeStore from '@o/store'
const { options, isPro, isLocked } = DarkModeStore()

import AnalyticsChart from './AnalyticsChart.vue';

</script>

<template>
    <Row transparent gap="5">
        <!-- graph settings  -->
        <Row space gap="5">
            <Row transparent>
                <Toggle v-model="options.analytics_enabled">{{__('Dark Mode Analytics', 'wp-dark-mode')}}</Toggle>
                <Hints> {{__('Enable dark mode analytics to track how many times site visitors have used dark mode in a certain period.', 'wp-dark-mode')}}</Hints>
            </Row>
            <Row :blur="!options.analytics_enabled">
                
                <AnalyticsChart />
            </Row>
            <Row transparent :blur="!options.analytics_enabled">
                <Toggle v-model="options.analytics_enabled_dashboard_widget"> {{__('Display this dark mode usage chart on the WordPress Dashboard', 'wp-dark-mode')}}</Toggle>
                    
                <Hints>{{__('If you enable this then the chart above will be shown in your admin panel dashboard', 'wp-dark-mode')}}</Hints>
            </Row>
        </Row>
        <!-- Reporting  -->
        <Row space gap="5">
            <Row transparent :blur="!options.analytics_enabled" >
                <Toggle locked v-model="options.analytics_enabled_email_reporting">{{__('Email Reporting', 'wp-dark-mode')}} </Toggle>
                <Hints>{{__('Enable this feature to get the dark mode usage summery through email.', 'wp-dark-mode')}}</Hints>
            </Row>
            <Row transparent :blur="!options.analytics_enabled_email_reporting || !options.analytics_enabled" locked
                :ProBadge="false">
                <Heading>{{__('Reporting Frequency', 'wp-dark-mode')}} <Hints>{{__('Select the reporting frequency when the email will be send.', 'wp-dark-mode')}}</Hints>
                </Heading>
                <div class="w-40">
                    <Select v-model="options.analytics_email_reporting_frequency" :options="$default.analytics.email_reporting_frequency.options"> </Select>
                </div>
            </Row>
            <Row transparent :blur="!options.analytics_enabled_email_reporting || !options.analytics_enabled" locked
                :ProBadge="false">
                <Heading>{{__('Reporting Email', 'wp-dark-mode')}} <Hints>{{__('Enter the email where analytics report will be sent', 'wp-dark-mode')}}</Hints>
                </Heading>
                <Input v-model="options.analytics_email_reporting_address" placeholder="john.doe@mail.com" />
            </Row>
            <Row transparent :blur="!options.analytics_enabled_email_reporting || !options.analytics_enabled" locked
                :ProBadge="false">
                <Heading> {{__('Reporting Email Subject', 'wp-dark-mode')}}<Hints>{{__('Subject of the analytics report mail', 'wp-dark-mode')}}</Hints>
                </Heading>
                <Input v-model="options.analytics_email_reporting_subject"
                    placeholder="Weekly Dark Mode Usage Summary of [domain name]" />
            </Row>
        </Row>
    </Row>
</template>
